import React from 'react'
import Editor, { Toolbar, ToolbarGroup, Image, Heading, Table } from 'bxl-editor'
import './index.scss'
import { uploadProductImage } from '@services/productService'

function SizeChartEditor(props: any) {
  const { value, onChange } = props

  const onSimpleRequest = (options, onProgress): Promise<any> => {
    const { file, name, extension, width, height } = options
    const form = new FormData()
    form.append('thumbnail', file, name + '.' + extension)
    form.append('thumbdim', `${width}x${height}`)
    form.append('full', file, name + '.' + extension)
    form.append('fulldim', `${width}x${height}`)
    form.append('format', extension)
    form.append('topic', 'IMAGE_TEXT')
    return uploadProductImage(form, onProgress)
  }

  const parseImageResponse = (res: any) => {
    const image = res.full || res.thumbnail
    const content = document.body.querySelector('.ce-editor-content') as HTMLElement
    const scale = content?.offsetWidth ? (1.0 * image?.width / content?.offsetWidth) : 1
    return {
      url: image?.url || '',
      format: image?.format || 'jpg',
      width: image?.width ? image?.width / scale : 0,
      height: image?.height ? image?.height / scale : 0,
    }
  }

  return (
    <Editor
      value={value}
      onChange={onChange}
      options={{
        uploadImage: onSimpleRequest,
        parseImageResponse: parseImageResponse,
      }}
      plugins={
        <Toolbar>
          <ToolbarGroup>
            <Heading />
          </ToolbarGroup>
          <ToolbarGroup>
            <Image simpleRequest={onSimpleRequest} transformResponse={parseImageResponse} />
          </ToolbarGroup>
          <ToolbarGroup>
            <Table />
          </ToolbarGroup>
        </Toolbar>
      }
    />
  )
}

export default SizeChartEditor
